import React from 'react';

import AppTimeoutModal from 'features/TimeoutModal/AppTimeoutModal';
import UnloadPrompt from 'components/UnloadPrompt';
import EmbeddedBackButton from 'features/EmbeddedBackButton';

const ApplicationRoute: React.FC = ({ children }) => {
  return (
    <UnloadPrompt>
      <AppTimeoutModal>
        <EmbeddedBackButton />
        {children}
      </AppTimeoutModal>
    </UnloadPrompt>
  );
};

export default ApplicationRoute;
